<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'lg'">
    <fudis-heading [level]="2">{{ t("MODULE_CONTENT_APPROVAL_MODAL." + approvalRequestType + ".MODAL_TITLE") }}</fudis-heading>
    <div class="modal-body">
      <div class="row">
        <div class="col-12" data-cy="mca-app-description">
          <fudis-body-text class="guidance" [variant]="'md-light'">
            {{ moduleContentApplicationDescriptionText | localizedString }}
          </fudis-body-text>
        </div>
      </div>
      @if (moduleContentApplicationDescriptionUrl) {
        <div class="row">
          <div class="col-12 mt-md-3" data-cy="mca-app-description-link">
            <a
              fudisLink
              [title]="t(moduleContentApplicationDescriptionUrl | localizedString)"
              [href]="moduleContentApplicationDescriptionUrl | localizedString"
              [external]="true"></a>
          </div>
        </div>
      }
      <div class="col-12 situation-description mt-md-4">
        @if (parentModule.type !== "GroupingModule") {
          <fudis-body-text>
            <transloco
              key="{{ 'MODULE_CONTENT_APPROVAL_MODAL.' + approvalRequestType + '.SITUATION_DESCRIPTION' }}"
              [params]="{ modulename: parentModule.name | localizedString }"></transloco>
          </fudis-body-text>
        }
        @if (parentModule.type === "GroupingModule") {
          <fudis-body-text>
            <transloco
              key="{{ 'MODULE_CONTENT_APPROVAL_MODAL.' + approvalRequestType + '.SITUATION_DESCRIPTION_FOR_GROUPING_MODULE' }}"
              [params]="{ modulename: parentModule.name | localizedString }"></transloco>
          </fudis-body-text>
        }
      </div>
      <div class="row" [sisPlanStructureContext]="{ planStateObject, planData }">
        @if (planData && planStateObject) {
          <fudis-heading [level]="3" [variant]="'md'" class="fudis-mt-sm">{{ parentModule.name | localizedString }}</fudis-heading>
          @for (selectedModule of selectedModules; track selectedModule.id) {
            @let targetCredits = getTargetCredits(selectedModule);
            <fudis-body-text class="fudis-mb-sm" [variant]="'lg-regular'">
              {{ selectedModule.name | localizedString }}
              @if (targetCredits) {
                {{ " (" + (targetCredits | creditRange: "TEXT") + ")" }}
              }
              {{ " | " + ("ENTITY_NAMES." + selectedModule.type | translate) }}
            </fudis-body-text>
          }
          @for (courseUnit of selectedCourseUnits; track courseUnit.id) {
            <sis-plan-structure-course-unit
              class="fudis-mb-sm"
              [courseUnit]="planData.courseUnitsById[courseUnit.id]"
              [headingLevel]="4"
              [showCompletionMethodSelection]="false"
              [nameClickable]="false"
              [showAttainment]="false">
            </sis-plan-structure-course-unit>
          }
          @for (customStudyDraft of customStudyDrafts; track customStudyDraft.id) {
            <sis-plan-structure-custom-study-draft
              class="fudis-mb-sm"
              [customStudyDraft]="customStudyDraft"
              [nameClickable]="false"
              [headingLevel]="4">
            </sis-plan-structure-custom-study-draft>
          }
          @for (customCourseUnitAttainment of selectedCustomCourseUnitAttainments; track customCourseUnitAttainment.id) {
            <sis-plan-structure-custom-course-unit-attainment
              class="fudis-mb-sm"
              [customCourseUnitAttainment]="customCourseUnitAttainment"
              [nameClickable]="false"
              [headingLevel]="4">
            </sis-plan-structure-custom-course-unit-attainment>
          }
          <fudis-heading [level]="3" [variant]="'md'" class="fudis-mt-sm">{{
            t("MODULE_CONTENT_APPROVAL_MODAL." + approvalRequestType + ".APPLICATION_RATIONALE_TITLE")
          }}</fudis-heading>
        } @else {
          <div class="col-12">
            <sis-module-content-workflow-structure
              [parentModule]="parentModule"
              [selectedCourseUnits]="selectedCourseUnits"
              [selectedModules]="selectedModules"
              [selectedCustomCourseUnitAttainments]="selectedCustomCourseUnitAttainments"
              [selectedCustomModuleAttainments]="selectedCustomModuleAttainments"
              [customStudyDrafts]="customStudyDrafts"
              [attainments]="attainments">
            </sis-module-content-workflow-structure>
            @for (customStudyDraft of customStudyDrafts; track entityId($index, customStudyDraft)) {
              <sis-custom-study-draft-summary [customStudyDraft]="customStudyDraft"> </sis-custom-study-draft-summary>
            }
          </div>
        }
      </div>
      <div class="module-content-application-comment">
        <div class="row">
          <div class="form-group col-12">
            <sis-text-field
              [name]="'comment'"
              [control]="moduleContentCommentFormControl"
              [textarea]="true"
              [id]="'module-content-application-comment'"
              [label]="t('MODULE_CONTENT_APPROVAL_MODAL.' + approvalRequestType + '.APPLICATION_RATIONALE')"
              data-cy="module-content-application-rationale-textarea">
            </sis-text-field>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <sis-button [size]="'lg'" [hollow]="true" (clicked)="close()">{{ t("CANCEL") }} </sis-button>
      <sis-button [dataCy]="'module-content-application-submit'" [size]="'lg'" (clicked)="sendApplication()"
        >{{ t("MODULE_CONTENT_APPROVAL_MODAL." + approvalRequestType + ".SEND_APPLICATION") }}
      </sis-button>
    </div>
  </fudis-dialog>
</ng-container>
